import * as geoServices from '@/services/geo.js'

export default {
  async getUnitCoordinates({ state, commit }, filter) {
    const { data } = await geoServices.unitCoordinates(filter)
    commit('SET_OBJECT', { name: 'unitCoordinates', data, state })
  },
  async getClientesAtivosCoordinates({ state, commit }, filter) {
    const { data } = await geoServices.clientCoordinates(filter)
    commit('SET_OBJECT', { name: 'clientesAtivosCoordinates', data, state })
  },
  async getClientesInativosCoordinates({ state, commit }, filter) {
    const { data } = await geoServices.clientCoordinates(filter)
    commit('SET_OBJECT', { name: 'clientesInativosCoordinates', data, state })
  },
  async getClientesComDadosCoordinates({ state, commit }, filter) {
    const { data } = await geoServices.clientCoordinates(filter)
    commit('SET_OBJECT', { name: 'clientesComDadosCoordinates', data, state })
  },
  async getClientesAtivosGeoStatus({ state, commit }, filter) {
    const { data } = await geoServices.clientGeoStatus(filter)
    commit('SET_OBJECT', { name: 'clientesAtivosStatus', data, state })
  },
  async getClientesInativosGeoStatus({ state, commit }, filter) {
    const { data } = await geoServices.clientGeoStatus(filter)
    commit('SET_OBJECT', { name: 'clientesInativosStatus', data, state })
  },
  async getClientesGeoStatus({ state, commit }, filter) {
    const { data } = await geoServices.clientGeoStatus(filter)
    return data
  },
}
